import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Grid,
  FormControlLabel,
  Radio,
  RadioGroup,
  Button,
} from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ValidatedDatePicker from "../../compartidos/ValidatedDatePicker";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import { nuevoPrestadorPresupuesto } from "../../../actions/autorizaciones/Autorizaciones";
import AutoCompletePrestadorPresupuesto from "../UI/AutoCompletePrestadorPresupuesto";
import { TIPOS_PRESUPUESTO } from "../../../utils/constants";

export const FormSolicitudPresupuesto = (props) => {
  const dispatch = useDispatch();
  const {
    // celular,
    conInternacion,
    fechaPrescripcion,
    fechaProgramada,
    fechaVencimiento,
    valor,
    cuitPrestador,
    nombrePrestador,
    idTipoPresupuesto,
    fechaOrden,
    fechaCarga,
    fechaCirugia,
    soloMateriales
    // idMotivoInternacion = "0",
    // telefono,
  } = props.formValues;

  const [conInternacionValue, setConInternacionValue] = useState(
    soloMateriales ? "materiales" : conInternacion ? "internacion" : "ambulatorio"
  );
  
  const [existePrestador, setExistePrestador] = useState((idTipoPresupuesto === 1 || idTipoPresupuesto === '') ? true : false);

  useEffect(() => {
    //FechaPrescripcion     &   //fechaVencimiento
    ValidatorForm.addValidationRule("isAfterToday", (value) => {
      if (!moment(value).isValid() || moment(value).isAfter(moment(), "day")) {
        return false;
      }
      return true;
    });

    //FechaProgramada
    ValidatorForm.addValidationRule("isBeforeFechaPrescripcion", (value) => {
      if (
        !moment(value).isValid() ||
        moment(value).isBefore(moment(fechaPrescripcion), "day")
      ) {
        return false;
      }
      return true;
    });

    //FechaProgramada
    ValidatorForm.addValidationRule("isBeforeToday", (value) => {
      if (!moment(value).isValid() || moment(value).isBefore(moment(), "day")) {
        return false;
      }
      return true;
    });
  });

  const handleBuscarPrestador = cuitPrestador => {
    dispatch(nuevoPrestadorPresupuesto(cuitPrestador, props.setHaveChangeValues, props.setearVariosValores/* , setExistePrestador */));
  }


  return (
    <React.Fragment>
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: ".7rem",
        }}
      >
        <RadioGroup
          row
          value={conInternacionValue}
          defaultValue={conInternacionValue}
          onChange={(e) => {
            props.setHaveChangeValues(true);
            setConInternacionValue(e.target.value);
            props.setearVariosValores({
              conInternacion: e.target.value === "internacion",
              soloMateriales: e.target.value === "materiales",
              idMotivoInternacion: "0",
              fechaPrescripcion: "",
              fechaProgramada: "",
              telefono: "",
              celular: "",
            });
          }}
        >
          <FormControlLabel
            value={"ambulatorio"}
            control={<Radio />}
            label="Ambulatorio"
          />
          <FormControlLabel
            value={"internacion"}
            control={<Radio />}
            label="Con internación"
          />
          <FormControlLabel
            value={"materiales"}
            control={<Radio />}
            label="Solo Materiales"
          />
        </RadioGroup>
      </Grid>
      <Grid container style={{ justifyContent: 'center' }} spacing={2}>
        {/* <Grid item xs={2}></Grid> */}
        <Grid item xs={12} md={4}>
          <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
            <ValidatedDatePicker
              fullWidth={true}
              margin="normal"
              format="dd/MM/yyyy"
              okLabel="Aceptar"
              clearLabel="Limpiar"
              cancelLabel="Cancelar"
              label="Fecha Orden"
              name="fechaOrden"
              value={
                fechaOrden !== undefined &&
                  moment(fechaOrden).isValid()
                  ? moment(fechaOrden)
                  : null      //moment().add(30, 'days')
              }
              onChange={(e) => {
                props.setHaveChangeValues(true);
                props.setearValor("fechaOrden", e);
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              minDate={new Date()}
              validators={[
                "required",
                "isBeforeToday",
              ]}
              errorMessages={[
                "La fecha de orden de presupuesto es requerida",
                "La fecha de orden de presupuesto no puede ser menor a la fecha actual",
              ]}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} md={4}>
          <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
            <ValidatedDatePicker
              fullWidth={true}
              margin="normal"
              format="dd/MM/yyyy"
              okLabel="Aceptar"
              clearLabel="Limpiar"
              cancelLabel="Cancelar"
              label="Fecha Carga"
              name="fechaCarga"
              value={
                fechaCarga !== undefined &&
                  moment(fechaCarga).isValid()
                  ? moment(fechaCarga)
                  : null      //moment().add(30, 'days')
              }
              onChange={(e) => {
                props.setHaveChangeValues(true);
                props.setearValor("fechaCarga", e);
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              minDate={new Date()}
              validators={[
                "required",
                "isBeforeToday",
              ]}
              errorMessages={[
                "La fecha de carga es requerida",
                "La fecha de carga no puede ser menor a la fecha actual",
              ]}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} md={4}>
          <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
            <ValidatedDatePicker
              fullWidth={true}
              margin="normal"
              format="dd/MM/yyyy"
              okLabel="Aceptar"
              clearLabel="Limpiar"
              cancelLabel="Cancelar"
              label="Fecha Cirugía"
              name="fechaCirugia"
              value={
                fechaCirugia !== undefined &&
                  moment(fechaCirugia).isValid()
                  ? moment(fechaCirugia)
                  : null      //moment().add(30, 'days')
              }
              onChange={(e) => {
                props.setHaveChangeValues(true);
                props.setearValor("fechaCirugia", e);
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              minDate={new Date()}
            /*validators={[
                "isBeforeToday",
            ]}
            errorMessages={[
                "La fecha de Cirugía no puede ser menor a la fecha actual",
            ]}*/
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} md={4}>
          <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
            <ValidatedDatePicker
              fullWidth={true}
              margin="normal"
              format="dd/MM/yyyy"
              okLabel="Aceptar"
              clearLabel="Limpiar"
              cancelLabel="Cancelar"
              label="Fecha Vencimiento"
              name="fechaVencimiento"
              value={
                fechaVencimiento !== undefined &&
                  moment(fechaVencimiento).isValid()
                  ? moment(fechaVencimiento)
                  : null      //moment().add(30, 'days')
              }
              onChange={(e) => {
                props.setHaveChangeValues(true);
                props.setearValor("fechaVencimiento", e);
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              minDate={new Date()}
              validators={[
                "required",
                "isBeforeToday",
              ]}
              errorMessages={[
                "La fecha vencimiento es requerida",
                "La fecha vencimiento no puede ser menor a la fecha actual",
              ]}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} md={4}>
          <TextValidator
            style={{ marginTop: "1rem", /* marginLeft: "1rem" */ }}
            label="Valor Presupuesto"
            name="valor"
            fullWidth
            onChange={(e) => {
              props.setHaveChangeValues(true);
              props.setearValor("valor", e.target.value);
            }}
            // InputLabelProps={{ shrink: true }}  
            value={valor}
            validators={['required', 'isPositive']}
            errorMessages={['El valor es requerido', 'Solo se permiten números']}
          />
        </Grid>
      </Grid>
      <Grid container style={{ justifyContent: 'center' }} spacing={2}>
        {existePrestador
          ?
          // cuitPrestador === '' || nombrePrestador === '' 
          //   ?
          <>
            <Grid item xs={8} md={8}>
              {/* <InputLabel shrink>Prestador Existente</InputLabel> */}
              <AutoCompletePrestadorPresupuesto
                autoCompleteValue={
                  idTipoPresupuesto === TIPOS_PRESUPUESTO.CON_CONTRATO
                    ? {
                      prestadorCuit: cuitPrestador,
                      prestadorNombreApellido: nombrePrestador,
                      efectorFacturacionRazonSocial: "",
                      efectorFacturacionCuit: "",
                    }
                    : null
                }
                onChangeHandler={(value) => {
                  if (value)
                    props.setearVariosValores({
                      idTipoPresupuesto: TIPOS_PRESUPUESTO.CON_CONTRATO,
                      cuitPrestador: value.prestadorCuit,
                      nombrePrestador: value.prestadorNombreApellido,
                      idPrestador: value.idPrestador,
                      idCartillaPrestador: value.idCartillaPrestador,
                      idEfectorFacturacion: value.idEfectorFacturacion,
                      /*
                      efectorFacturacionRazonSocial: value.efectorFacturacionRazonSocial,
                      efectorFacturacionCuit: value.efectorFacturacionCuit,
                      */
                    });
                  else
                    props.setearVariosValores({
                      idTipoPresupuesto: '',
                      cuitPrestador: '',
                      nombrePrestador: '',
                      idPrestador: '',
                      idCartillaPrestador: '',
                      idEfectorFacturacion: '',
                    });
                }}
              />
            </Grid>
            <Grid item xs={4} md={2}>
              <Button
                style={{ marginTop: 10 }}
                variant="contained"
                color="primary"
                onClick={() => {
                  setExistePrestador(false);
                  props.setearVariosValores({
                    cuitPrestador: '',
                    nombrePrestador: '',
                    idTipoPresupuesto: '',
                  });
                }}
              >
                Nuevo
              </Button>
            </Grid>
          </>
          // :
          //   <>
          //     <Grid item xs={4} md={2}>
          //         <Button
          //           style={{marginTop: 32}}
          //           variant="contained"
          //           color="primary"
          //           onClick={() => {
          //             setExistePrestador(false);
          //             props.setearVariosValores({
          //               cuitPrestador: '',
          //               nombrePrestador: '',
          //             });
          //           }}
          //           >
          //           Nuevo
          //         </Button>
          //     </Grid>
          //     <Grid item xs={8} md={4}>
          //         <TextValidator
          //             margin="normal"
          //             value={cuitPrestador}
          //             disabled
          //             inputProps={{ maxLength: 11}}
          //             fullWidth
          //             label="Cuit Prestador Existente"
          //             name="cuitPrestador"
          //             autoComplete="off"
          //             // InputLabelProps={{ shrink: true }}  
          //             validators={[
          //                 "required", 
          //                 "isPositive", 
          //                 "minNumber:10000000000"
          //             ]}
          //             errorMessages={[
          //                 "El valor es requerido",
          //                 "Solo se permiten números",
          //                 "El cuit debe tener 11 dígitos"
          //             ]}
          //         />
          //     </Grid>
          //     <Grid item xs={12} md={6}>
          //         <TextValidator
          //             margin="normal"
          //             value={nombrePrestador}
          //             disabled
          //             inputProps={{ maxLength: 100}}
          //             fullWidth
          //             label="Nombre Prestador Existente"
          //             name="nombrePrestador"
          //             autoComplete="off"
          //             // InputLabelProps={{ shrink: true }}  
          //             validators={["required"]}
          //             errorMessages={["Debe ingresar un cuit y validarlo"]}
          //         />
          //     </Grid>
          //   </>
          :
          <>
            <Grid item xs={8} md={4}>
              <TextValidator
                margin="normal"
                value={cuitPrestador}
                // disabled={props.disabled}
                inputProps={{ maxLength: 11 }}
                onChange={(e) => {
                  props.setHaveChangeValues(true);
                  props.setearVariosValores({
                    cuitPrestador: e.target.value,
                    nombrePrestador: '',
                  });
                  // setExistePrestador(false);
                }}
                fullWidth
                label="Cuit Nuevo Prestador"
                name="cuitPrestador"
                autoComplete="off"
                // InputLabelProps={{ shrink: true }}  
                validators={[
                  "required",
                  "isPositive",
                  "minNumber:10000000000"
                ]}
                errorMessages={[
                  "El valor es requerido",
                  "Solo se permiten números",
                  "El cuit debe tener 11 dígitos"
                ]}
              />
            </Grid>
            <Grid item xs={4} md={2}>
              <Button
                style={{ marginTop: 32 }}
                variant="contained"
                color="primary"
                // size="small"
                onClick={() => { handleBuscarPrestador(cuitPrestador) }}
              >
                Validar
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextValidator
                margin="normal"
                value={nombrePrestador}
                // disabled={existePrestador}
                disabled={true}
                inputProps={{ maxLength: 100 }}
                onChange={(e) => {
                  props.setHaveChangeValues(true);
                  props.setearValor("nombrePrestador", e.target.value);
                }}
                fullWidth
                label="Nombre Nuevo Prestador"
                name="nombrePrestador"
                autoComplete="off"
                // InputLabelProps={{ shrink: true }}  
                validators={["required"]}
                errorMessages={["Debe ingresar un cuit y validarlo"]}
              />
            </Grid>
          </>
        }
      </Grid>
      {conInternacion && (
        <React.Fragment>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <ValidatedDatePicker
                  fullWidth={true}
                  margin="normal"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  label="Fecha Prescripción"
                  name="fechaPrescripcion"
                  value={
                    fechaPrescripcion !== undefined &&
                      moment(fechaPrescripcion).isValid()
                      ? moment(fechaPrescripcion)
                      : null
                  }
                  onChange={(e) => {
                    props.setHaveChangeValues(true);
                    props.setearValor("fechaPrescripcion", e);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  maxDate={new Date()}
                  validators={
                    props.practicaElegida?.requiereFechaPrescripcion && [
                      "required",
                      "isAfterToday",
                    ]
                  }
                  errorMessages={
                    props.practicaElegida?.requiereFechaPrescripcion && [
                      "La fecha de prescripción es requerida",
                      "La fecha de prescripción no puede ser mayor a la fecha actual",
                    ]
                  }
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} md={6}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <ValidatedDatePicker
                  fullWidth={true}
                  margin="normal"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  label="Fecha Programada"
                  name="fechaProgramada"
                  value={
                    fechaProgramada !== undefined &&
                      moment(fechaProgramada).isValid()
                      ? moment(fechaProgramada)
                      : null
                  }
                  onChange={(e) => {
                    props.setHaveChangeValues(true);
                    props.setearValor("fechaProgramada", e);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  minDate={fechaPrescripcion}
                  validators={
                    props.practicaElegida?.requiereFechaProgramada && [
                      "required",
                      "isBeforeFechaPrescripcion",
                      "isBeforeToday",
                    ]
                  }
                  errorMessages={
                    props.practicaElegida?.requiereFechaProgramada && [
                      "La fecha programada es requerida",
                      "La fecha programada no puede ser menor a la fecha fecha de prescripción",
                      "La fecha programada no puede ser menor a la fecha actual",
                    ]
                  }
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
          {/* <Grid
            item
            xs={12}
            style={{ marginTop: "1.5rem", marginLeft: "1rem" }}
          >
            <FormControl>
              <FormLabel>Motivo de internación:</FormLabel>
              <RadioGroup
                value={idMotivoInternacion?.toString()}
                defaultValue={idMotivoInternacion?.toString()}
                onChange={(e) => {
                  props.setHaveChangeValues(true);
                  props.setearVariosValores({
                    idMotivoInternacion: e.target.value,
                    telefono: e.target.value === "4" ? "" : telefono,
                    celular: e.target.value === "4" ? "" : celular,
                  });
                }}
              >
                <FormControlLabel
                  value={"1"}
                  control={<Radio />}
                  label="Accidente en via pública"
                />
                <FormControlLabel
                  value={"2"}
                  control={<Radio />}
                  label="Accidente de trabajo"
                />
                <FormControlLabel
                  value={"3"}
                  control={<Radio />}
                  label="Otro tipo de accidente con denuncia policial"
                />
                <FormControlLabel
                  value={"4"}
                  control={<Radio />}
                  label="Ninguno"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          {idMotivoInternacion &&
            parseInt(idMotivoInternacion) > 0 &&
            parseInt(idMotivoInternacion) < 4 && (
              <React.Fragment>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextValidator
                      fullWidth
                      margin="normal"
                      label="Tel. Particular(10 dígitos sin el 0)"
                      name="telefono"
                      value={telefono}
                      onChange={(e) => {
                        props.setHaveChangeValues(true);
                        props.handleInputChange(e);
                      }}
                      validators={
                        celular === ""
                          ? [
                              "required",
                              "isNumber",
                              "maxNumber:9999999999",
                              "minNumber:999999999",
                            ]
                          : [
                              "isNumber",
                              "maxNumber:9999999999",
                              "minNumber:999999999",
                            ]
                      }
                      errorMessages={
                        celular === ""
                          ? [
                              "El teléfono es requerido",
                              "Sólo números",
                              "Verifique su teléfono",
                              "Verifique su teléfono",
                            ]
                          : [
                              "Sólo números",
                              "Verifique su teléfono",
                              "Verifique su teléfono",
                            ]
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextValidator
                      fullWidth
                      margin="normal"
                      label="Tel. Celular(10 dígitos sin 0 ni 15)"
                      name="celular"
                      value={celular}
                      onChange={(e) => {
                        props.setHaveChangeValues(true);
                        props.handleInputChange(e);
                      }}
                      maxLength="10"
                      validators={
                        telefono === ""
                          ? [
                              "required",
                              "isNumber",
                              "maxNumber:9999999999",
                              "minNumber:999999999",
                            ]
                          : [
                              "isNumber",
                              "maxNumber:9999999999",
                              "minNumber:999999999",
                            ]
                      }
                      errorMessages={
                        telefono === ""
                          ? [
                              "El celular es requerido",
                              "Sólo números",
                              "Verifique su celular",
                              "Verifique su celular",
                            ]
                          : [
                              "Sólo números",
                              "Verifique su celular",
                              "Verifique su celular",
                            ]
                      }
                    />
                  </Grid>
                </Grid>
              </React.Fragment>
            )} */}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};